import React, { useEffect, useRef } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import FormikGrid from '../../common/formik/FormikGrid';
import FormikButton from '../../common/formik/FormikButton';
import FormikTextField from '../../common/formik/FormikTextField';
import { useCreateChangeOrder } from './ChangeOrder.hook';
import { ChangeOrder } from './ChangeOrder.interface';

export interface ChangeOrderCreateDialogProps {
  open: boolean;
  onCreate?: (changeOrder: ChangeOrder) => void;
  onCancel?: () => void;
}

export const ChangeOrderCreateDialog: React.FC<
  ChangeOrderCreateDialogProps
> = props => {
  const { open, onCreate, onCancel } = props;
  const onCreateRef = useRef(onCreate);
  const formikRef = useRef<FormikProps<{ name: string }> | null>(null);
  const { error, isLoading, data, post } = useCreateChangeOrder();

  useEffect(() => {
    onCreateRef.current = onCreate;
  }, [onCreate]);

  useEffect(() => {
    formikRef.current?.setSubmitting(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (data) {
      onCreateRef.current?.(data);
    }
  }, [data]);

  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={formik => (formikRef.current = formik)}
        initialValues={{ name: '' }}
        onSubmit={changeOrder => post({ ...changeOrder })}
      >
        <Form autoComplete='off'>
          <DialogTitle>New Change Order</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField name='name' label='Name' autoFocus />
            </FormikGrid>
            {error && (
              <Alert severity='error'>Error occurred. {error.message}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};
